import React from 'react';
import './video.scss'; // TODO: type.. src

var Video = function Video(_ref) {
  var width = _ref.width,
      height = _ref.height,
      controls = _ref.controls,
      autoPlay = _ref.autoPlay,
      loop = _ref.loop,
      className = _ref.className,
      src = _ref.src,
      type = _ref.type;
  return /*#__PURE__*/React.createElement("video", {
    className: "video",
    width: width,
    height: height,
    controls: controls,
    autoPlay: autoPlay,
    loop: loop,
    muted: true
  }, /*#__PURE__*/React.createElement("source", {
    className: "video__source " + (className && className),
    src: src,
    type: type
  }), "Sorry, your browser doesn't support embedded videos.");
};

export default Video;